import { useApolloClient } from "@apollo/client";
import { RootState, useAppDispatch, useAppSelector } from "../../../Store";
import { Graph_QL } from "../..";
import { useCallback } from "react";
import { CHANGE_GATE_STATE, GATE_CONTROL, gateControlResponse, STATION_AUTO_TUNE, stationAutoTuneInput, stationAutoTuneResponse, stationChangeStateInput, stationChangeStateResponse, stationGateControlInput } from "./qyeryGateControl";
import { batchedMutation } from "../batchedMutation";

export const useGateControl = () => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();

  const domain = useAppSelector((state: RootState) => state.activeData?.farm);

  // #region | Gate Control
  const gateControl = useCallback(async (dut: stationGateControlInput[]): Promise<gateControlResponse | undefined> => {
    if (!domain) return;

    try {
      const result = await client.mutate({ mutation: GATE_CONTROL, variables: { domain, values: dut }});
      return result.data ?? undefined;
    } catch (error) {
      console.log(error);
      return;
    }
  }, [client, domain])
  // #endregion

  // #region | Change Gate State
  const gateState = useCallback(async (dut: stationChangeStateInput[]): Promise<stationChangeStateResponse | undefined> => {
    if (!domain) return;

    try {
      const result = await client.mutate({ mutation: CHANGE_GATE_STATE, variables: { domain, values: dut } })
      return result.data ?? undefined
    } catch (error) {
      console.log(error)
      return 
    }
  }, [client, domain])
  // #endregion

  return { gateControl, gateState }
}

export const useStationAutoTune = () => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();

  const domain = useAppSelector((state: RootState) => state.activeData?.farm);

  const autoTune = useCallback(async (dut: stationAutoTuneInput[]): Promise<stationAutoTuneResponse | undefined> => {
    if (!domain) return;

    try {
      const result = await client.mutate({ mutation: STATION_AUTO_TUNE, variables: { domain, values: dut }})
      return result.data ?? undefined
    } catch (error) {
      console.log(error)
      return 
    }
  }, [client, domain])
  // #endregion

  return { autoTune }
}